import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootReducer from './reducers'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

const middleWare = [thunk]
// setting persistence on the browser session
const persistConfig = {
  key: 'root',
  storage
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

const configureStore = () => {
  // creating the redux store with persisted storage, and applying thunk as our middleware
  const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middleWare)))
  const persistor = persistStore(store)
  return { store, persistor }
}

export default configureStore
